import { faqList } from "../data";
import HotProduct from "@/components/hot-product.vue";
export default {
  name: "FaqList",
  components: {
    HotProduct
  },
  data() {
    return {
      faqList
    };
  },
  methods: {
    clickItem(id) {
      this.$router.push("/faq/detail?id=" + id);
    }
  }
};
